import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRedirectLink = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ShortLink/RedirectLink?` + params, null, undefined);

export const GenerateToken = (data: any) =>
    POST_ENC(`${BASE_URL}/api/ShortLink/GenerateToken`, data, false);